/**
 * @desc: проверка на наличие элемента на странице
 * @param node
 * @returns {boolean}
 */
const isInPage = (node) => ((node === document.body) ? false : document.body.contains(node));

export { isInPage };
